import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Logo: React.FC<LogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-32 h-12',
    md: 'w-40 h-16',
    lg: 'w-48 h-20'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <img
        src="/Images/logo-trans.png"
        alt="SIIS Logo"
        className="w-full h-full object-contain"
      />
    </div>
  );
};
